/* eslint-disable @typescript-eslint/no-unused-vars */
const GOFUR = '10'
const ABDUBORIY = '11'
const ISMOIL = '18'
const MUHAMMAD_RIZO = '16'

export const NODE_ENV = process.env.NODE_ENV || 'development'

export const API_SCHEME = NODE_ENV !== 'development' ? ('https' as const) : ('http' as const)
export const API_WS_SCHEME = NODE_ENV !== 'development' ? 'wss' : 'ws'

export const API_LOCAL = `192.168.1.${ABDUBORIY}:9123` as const //'localhost:9120'
export const API_LIVE = 'api.edulab.app' as const
export const API_HOST = NODE_ENV !== 'development' ? API_LIVE : API_LOCAL

export const API_PROJECT = '/edulab_udea_demo' as const
export const API_V1 = '/api/v1' as const
export const API_URL = `${API_HOST}${API_PROJECT}${API_V1}` as const
